import { render } from "./AddIconDialog.vue?vue&type=template&id=237928dd"
import script from "./AddIconDialog.vue?vue&type=script&lang=js"
export * from "./AddIconDialog.vue?vue&type=script&lang=js"

import "./AddIconDialog.vue?vue&type=style&index=0&id=237928dd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__